import { Component, computed, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Stage } from '../../enums';

interface StageColors {
    fg: string;
    bg: string;
}

const DEFAULT_COLORS: StageColors = { fg: '#20883A', bg: '#ffffff' };

const STAGE_COLORS: ReadonlyMap<string, StageColors> = new Map<string, StageColors>([
    [Stage.LOCAL, { fg: '#ffffff', bg: '#20883A' }], // Green
    [Stage.DEV, { fg: '#ffffff', bg: '#018484' }], // Teal
    [Stage.QA, { fg: '#000000', bg: '#FBBF28' }], // Amber
    [Stage.TEST, { fg: '#000000', bg: '#1E90FF' }], // DodgerBlue
    [Stage.PROD, { fg: '#ffffff', bg: '#E32B26' }] // Red
]);

@Component({
    selector: 'app-banner',
    templateUrl: './banner.component.html',
    standalone: true,
    imports: [TranslateModule],
    host: {
        class: 'w-full h-[30px] flex items-center justify-center text-sm shrink-0',
        '[style.color]': 'fgColor()',
        '[style.backgroundColor]': 'bgColor()'
    }
})
export class BannerComponent {
    public readonly stage = input.required<Stage | string>();

    protected readonly fgColor = computed(() => (STAGE_COLORS.get(this.stage()) ?? DEFAULT_COLORS).fg);
    protected readonly bgColor = computed(() => (STAGE_COLORS.get(this.stage()) ?? DEFAULT_COLORS).bg);
}
